(function () {
	function clamp(i, len) {
		if (!len) return 0;
		return Math.max(0, Math.min(i, len - 1));
	}

	function initHomeTabs(root) {
		const dataWrap = root.querySelector('[data-home-tabs-data]');
		const navWrap = root.querySelector('[data-home-tabs-nav]');
		const panelsWrap = root.querySelector('[data-home-tabs-panels]');
		if (!dataWrap || !navWrap || !panelsWrap) return;

		const rawTabs = Array.from(
			dataWrap.querySelectorAll('[data-home-tab]')
		);
		if (!rawTabs.length) return;

		const instanceId = root.getAttribute('data-instance-id') || 'x';
		const baseId = `home-tabs-${instanceId}`;

		const ACTIVE_BTN_CLASS = 'is-active';
		const ACTIVE_PANEL_CLASS = 'is-active';

		const tabs = rawTabs.map((el) => {
			const navTitle =
				el
					.querySelector('[data-home-tab-nav-title]')
					?.textContent?.trim() || '';
			const navText =
				el
					.querySelector('[data-home-tab-nav-text]')
					?.textContent?.trim() || '';
			const img = el.querySelector('img[data-home-tab-image]');
			const link = el.querySelector('a[data-home-tab-link]');
			const body =
				el.querySelector('[data-home-tab-body]')?.innerHTML || '';

			return {
				navTitle,
				navText,
				imageUrl: img?.getAttribute('src') || '',
				imageAlt: img?.getAttribute('alt') || '',
				linkText: link?.textContent?.trim() || '',
				linkUrl: link?.getAttribute('href') || '#',
				bodyHtml: body,
			};
		});

		const arrows = navWrap.querySelector('.home-tabs__nav-arrows');
		navWrap
			.querySelectorAll('.home-tabs__nav-button')
			.forEach((n) => n.remove());
		panelsWrap.innerHTML = '';

		let active = clamp(
			parseInt(root.getAttribute('data-active-index') || '0', 10),
			tabs.length
		);

		tabs.forEach((t, i) => {
			const tabId = `${baseId}-tab-${i}`;
			const panelId = `${baseId}-panel-${i}`;

			const btn = document.createElement('button');
			btn.type = 'button';
			btn.className = 'home-tabs__nav-button';
			btn.setAttribute('role', 'tab');
			btn.id = tabId;
			btn.setAttribute('aria-controls', panelId);
			btn.setAttribute('aria-selected', i === active ? 'true' : 'false');
			btn.tabIndex = i === active ? 0 : -1;

			if (i === active) btn.classList.add(ACTIVE_BTN_CLASS);

			btn.innerHTML =
				'<p class="home-tabs__nav-title"></p><p class="home-tabs__nav-text"></p>';
			btn.querySelector('.home-tabs__nav-title').textContent = t.navTitle;
			btn.querySelector('.home-tabs__nav-text').textContent = t.navText;

			btn.addEventListener('click', () => setActive(i, true));

			btn.addEventListener('keydown', (e) => {
				if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
					e.preventDefault();
					setActive(clamp(active + 1, tabs.length), true);
				}
				if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
					e.preventDefault();
					setActive(clamp(active - 1, tabs.length), true);
				}
				if (e.key === 'Home') {
					e.preventDefault();
					setActive(0, true);
				}
				if (e.key === 'End') {
					e.preventDefault();
					setActive(tabs.length - 1, true);
				}
			});

			navWrap.insertBefore(btn, arrows || null);
		});

		// --- PANELS ---
		tabs.forEach((t, i) => {
			const tabId = `${baseId}-tab-${i}`;
			const panelId = `${baseId}-panel-${i}`;

			const panel = document.createElement('div');
			panel.className = 'home-tabs__body';
			panel.setAttribute('role', 'tabpanel');
			panel.id = panelId;
			panel.setAttribute('aria-labelledby', tabId);
			panel.hidden = i !== active;

			// active class
			if (i === active) panel.classList.add(ACTIVE_PANEL_CLASS);

			panel.innerHTML = `
				${
					t.imageUrl
						? `<img src="${escapeHtmlAttr(
								t.imageUrl
						  )}" alt="${escapeHtmlAttr(
								t.imageAlt
						  )}" class="home-tabs__image">`
						: ''
				}
				<div class="home-tabs__body-content">
${
	t.linkText
		? `<a href="${escapeHtmlAttr(t.linkUrl)}" class="home-tabs__tab-link">
				${escapeHtml(t.linkText)}
				<svg width="26" height="40" viewBox="0 0 26 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
					<path d="M25.1562 8.75V26.25C25.1562 26.9531 24.5312 27.5 23.9062 27.5C23.2031 27.5 22.6562 26.9531 22.6562 26.25V11.7969L2.26562 32.1875C2.03125 32.4219 1.71875 32.5 1.40625 32.5C1.01562 32.5 0.703125 32.4219 0.46875 32.1875C0 31.7188 0 30.8594 0.46875 30.3906L20.8594 10H6.32812C5.70312 10 5.07812 9.375 5.15625 8.75C5.15625 8.04688 5.70312 7.5 6.40625 7.5H23.9062C24.5312 7.5 25.1562 8.125 25.1562 8.75Z" fill="white"/>
				</svg>
		   </a>`
		: ''
}
					<div class="home-tabs__body-text"></div>
				</div>
			`;

			panel.querySelector('.home-tabs__body-text').innerHTML = t.bodyHtml;
			panelsWrap.appendChild(panel);
		});

		// --- ARROWS ---
		const prevBtn = root.querySelector('[data-tabs-prev]');
		const nextBtn = root.querySelector('[data-tabs-next]');

		if (prevBtn) {
			prevBtn.addEventListener('click', () =>
				setActive(clamp(active - 1, tabs.length), true)
			);
		}

		if (nextBtn) {
			nextBtn.addEventListener('click', () =>
				setActive(clamp(active + 1, tabs.length), true)
			);
		}

		function setActive(i, focusTab = false) {
			active = clamp(i, tabs.length);

			const tabButtons = navWrap.querySelectorAll(
				".home-tabs__nav-button[role='tab']"
			);
			const panels = panelsWrap.querySelectorAll(
				".home-tabs__body[role='tabpanel']"
			);

			tabButtons.forEach((b, idx) => {
				const isOn = idx === active;
				b.setAttribute('aria-selected', isOn ? 'true' : 'false');
				b.tabIndex = isOn ? 0 : -1;
				b.classList.toggle(ACTIVE_BTN_CLASS, isOn);
				if (isOn && focusTab) b.focus();
			});

			panels.forEach((p, idx) => {
				const isOn = idx === active;
				p.hidden = !isOn;
				p.classList.toggle(ACTIVE_PANEL_CLASS, isOn);
			});
		}

		function escapeHtml(str) {
			return String(str || '')
				.replaceAll('&', '&amp;')
				.replaceAll('<', '&lt;')
				.replaceAll('>', '&gt;');
		}

		function escapeHtmlAttr(str) {
			return escapeHtml(str).replaceAll('"', '&quot;');
		}
	}

	function boot() {
		document.querySelectorAll("[data-home-tabs='true']").forEach((root) => {
			if (root.__homeTabsInit) return;
			root.__homeTabsInit = true;
			initHomeTabs(root);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}
})();
